import { render, staticRenderFns } from "./BookingHistoryItem.vue?vue&type=template&id=2cd88081&scoped=true&"
import script from "./BookingHistoryItem.vue?vue&type=script&lang=js&"
export * from "./BookingHistoryItem.vue?vue&type=script&lang=js&"
import style0 from "./BookingHistoryItem.vue?vue&type=style&index=0&id=2cd88081&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd88081",
  null
  
)

export default component.exports